module.exports = __webpack_public_path__ + "img/svg/twitch.f003c20bee534c2c6ce78cf2fb6eec5a.svg";